import React from "react";
import type { ViewComponent } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import type BulkExemptionsViewModel from "viewModels/callCenter/actions/bulkExemptionsViewModel";
import BulkExemptionsTableView from "./create/bulkExemptionsTableView";
import BulkExemptionsCancelTableView from "./terminate/bulkExemptionsCancelTableView";

const BulkExemptionsPreviewView: ViewComponent<BulkExemptionsViewModel> = observer(({ vm }) => {
  return (
    <>
      <div className="pb-6">
        <span>{vm.translate("warningInfo")}</span>
      </div>
      {!vm.isCancelation && <BulkExemptionsTableView vm={vm} />}
      {vm.isCancelation && <BulkExemptionsCancelTableView vm={vm} />}
    </>
  );
});

export default BulkExemptionsPreviewView;
